import { Component } from "react";
import { TYPING_TIMEOUT } from "../../../constants";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import TextFieldWithTypingTimeout from "../../Input/TextFieldWithTypingTimeout";

class InterventionEmailField extends Component {
    constructor(props) {
        super(props);

        let defaultValue = this.props.value.value_text;
        this.state = {
            value: defaultValue,
            timeout: TYPING_TIMEOUT,
            typedJustNow: false,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.typedJustNow) return state;

        let currentValue = props.value.value_text;
        state.value = currentValue;
        return state;
    }

    handleChange(value) {
        let fieldValue = this.props.value;
        fieldValue.value_text = value;

        this.props.fieldValueChange(fieldValue);

        this.setState({
            typedJustNow: false,
        });
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <TextFieldWithTypingTimeout
                onValueChange={this.handleChange.bind(this)}
                {...this.props.inputProperties}
                label={this.props.model.name}
                type={this.props.type}
                value={this.state.value}
                autoComplete={this.props.autoComplete}
                className={this.props.inputProperties.className + " full_size control-margin-top"}
            />
        );
    }
}

export default InterventionEmailField;
